import { UPDATE_FIREBASE_PROFILE } from "../actions/types"
import { identify } from "../utils/analytics"

export const authMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case UPDATE_FIREBASE_PROFILE:
      // call the signin and identify trackers.
      // we need to get the profile/auth objects here.
      // eslint-disable-next-line no-case-declarations
      const result = next(action)
      // eslint-disable-next-line no-case-declarations
      const {
        firebase: { auth, profile },
      } = store.getState()
      identify(auth.uid, {
        email: profile.email || auth.email,
        ...profile,
      })
      return result

    default:
      return next(action)
  }
}
